import { Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';


/**
 * The list of tabs on this page
 */
export enum FinanceAwardsPageTabId {
	Awards = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list if main tab droplist views on this page
 */
export enum FinanceAwardsPageViewId {
	Entrepreneurs = 1,
	Accelerators = 2,
	Trimesters = 3,
}


@Injectable({ providedIn: 'root' })
export class FinanceAwardsPageService extends PageTabsLayoutPageService<FinanceAwardsPageTabId, FinanceAwardsPageViewId> {

	private static readonly _viewDroplistItems1: DroplistItem<never, FinanceAwardsPageViewId>[] = [
		{
			uniqueId: FinanceAwardsPageViewId.Entrepreneurs, iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Entrepreneurs',
				hideText: 'never',
			},
			customSort: '1'
		},
		{
			uniqueId: FinanceAwardsPageViewId.Accelerators, iconContext: {
				iconClass: 'fa-user-graduate',
				iconStyle: 'fa-solid',
				text: 'Accelerators',
				hideText: 'never',
			},
			customSort: '2'
		},
		{
			uniqueId: FinanceAwardsPageViewId.Trimesters, iconContext: {
				iconClass: 'fa-user-graduate',
				iconStyle: 'fa-solid',
				text: 'Trimesters',
				hideText: 'never',
			},
			customSort: '3'
		},
	];

	constructor() {
		super(FinanceAwardsPageService._viewDroplistItems1, FinanceAwardsPageService.name, FinanceAwardsPageTabId.Awards, FinanceAwardsPageViewId.Entrepreneurs);
	}

	public get viewId() {
		return FinanceAwardsPageViewId;
	}
}